import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import classnames from "classnames";
import AppRating from "./AppRating";
import styles from "./index.css";

const NameRating = ({ formatTranslation, isNativeBanner, darkStars }) => {
  return (
    <div
      className={classnames(styles.ratingContainer, {
        [styles.nativeBannerDisplay]: isNativeBanner
      })}
    >
      <span className={styles.ratingText}>
        {formatTranslation("nativeappbanner_the_asos_app_text")}
      </span>
      <div className={styles.rating}>
        <AppRating darkStars={darkStars} showCount />
      </div>
    </div>
  );
};

NameRating.propTypes = {
  formatTranslation: PropTypes.func,
  className: PropTypes.string,
  isNativeBanner: PropTypes.bool,
  darkStars: PropTypes.bool
};

export default withTranslation(NameRating);
